import { Component } from '@angular/core';

@Component({
  selector: 'app-inspire-presentation',
  templateUrl: './inspire-presentation.component.html',
  styleUrls: ['./inspire-presentation.component.scss']
})
export class InspirePresentationComponent {

}
